document.addEventListener('DOMContentLoaded', function () {
  // For every product card wrapper
  document.querySelectorAll('.dd--a-main-card-add-to-card-btn').forEach(function (card) {
    const frontWrap  = card.querySelector('.dd--a-front-end-view-qty');
    const workingWrap = card.querySelector('.dd--a-working-qty');

    if (!frontWrap || !workingWrap) return;

    const frontInput   = frontWrap.querySelector('.quantity__input');
    const workingInput = workingWrap.querySelector('.quantity__input');

    if (!frontInput || !workingInput) return;

    // helper: clamp & align to step
    const normalize = (val) => {
      const min  = parseInt(frontInput.min || '1', 10);
      const step = parseInt(frontInput.step || '1', 10);
      const max  = frontInput.max ? parseInt(frontInput.max, 10) : null;

      let n = parseInt(val, 10);
      if (isNaN(n)) n = min;
      if (n < min) n = min;
      if (max && n > max) n = max;

      // align to the step grid relative to min
      const remainder = (n - min) % step;
      if (remainder !== 0) n = n - remainder;
      if (n < min) n = min;

      return n;
    };

    const syncToWorking = () => {
      const normalized = normalize(frontInput.value);
      if (String(frontInput.value) !== String(normalized)) {
        frontInput.value = normalized;
      }
      workingInput.value = normalized;

      // fire events so any theme JS listening to quantity changes reacts
      workingInput.dispatchEvent(new Event('input',  { bubbles: true }));
      workingInput.dispatchEvent(new Event('change', { bubbles: true }));
    };

    // Seed the hidden input with whatever the visible input shows
    syncToWorking();

    // Any manual typing in the visible box
    frontInput.addEventListener('input',  syncToWorking);
    frontInput.addEventListener('change', syncToWorking);

    // When the visible +/- buttons are clicked, the theme's quantity-input will
    // update the visible input; we mirror immediately after that UI tick.
    frontWrap.querySelectorAll('.quantity__button').forEach(function (btn) {
      btn.addEventListener('click', function () {
        requestAnimationFrame(syncToWorking);
      });
    });

    // As a final guard, when the Add to Cart button inside this card is pressed,
    // mirror one more time before submit.
    const submitBtn = card.querySelector('button[name="add"]');
    if (submitBtn) {
      submitBtn.addEventListener('click', syncToWorking, { capture: true });
    }
  });
});
